import { render, staticRenderFns } from "./Projetos.vue?vue&type=template&id=3573012a&scoped=true"
import script from "./Projetos.vue?vue&type=script&lang=js"
export * from "./Projetos.vue?vue&type=script&lang=js"
import style0 from "./Projetos.vue?vue&type=style&index=0&id=3573012a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573012a",
  null
  
)

export default component.exports